import { styled } from '@mui/material/styles'
import { StyledButton } from './StyledButton'
import { ButtonProps } from '@mui/material/Button'
import { brandedTokens } from '@/theme/tokens'

import { LinkProps as RouterLinkProps } from 'react-router-dom'

export type ToolbarButtonProps = Omit<ButtonProps, 'component'> &
    RouterLinkProps

export const ToolbarButton = styled(StyledButton, {
    shouldForwardProp: (prop) =>
        prop !== 'dense' && prop !== 'modalized' && prop !== 'sx',
})<ToolbarButtonProps>(({ theme, dense, variant, color = 'primary' }) => ({
    height: dense ? 32 : 42,
    minWidth: dense ? 32 : 42,

    '& .MuiButton-endIcon > svg': {
        fontSize: dense ? '0.875rem' : undefined,
    },

    '& .MuiButton-startIcon > svg': {
        fontSize: dense ? '0.875rem' : undefined,
    },

    ...(variant === 'outlined' && {
        backgroundColor: 'transparent',

        color: color
            ? color === 'primary'
                ? brandedTokens.brand.primary.main
                : color === 'secondary'
                ? theme.palette.grey[800]
                : theme.palette[color]?.main || theme.palette.grey[800]
            : theme.palette.grey[800],

        border: `1px solid ${
            color
                ? color === 'primary'
                    ? brandedTokens.brand.primary.light
                    : color === 'secondary'
                    ? theme.palette.grey[400]
                    : theme.palette[color]?.light || theme.palette.grey[400]
                : theme.palette.grey[400]
        }`,

        '&:hover': {
            color: color
                ? color === 'primary'
                    ? brandedTokens.brand.primary.dark
                    : color === 'secondary'
                    ? theme.palette.grey[900]
                    : theme.palette[color]?.dark || theme.palette.grey[900]
                : theme.palette.grey[900],
        },
    }),
}))
